import React from 'react'
import { Trans, WithTranslation, withTranslation } from 'react-i18next'
import apartamentImg from '../../../assets/room_types/green/apartament.png'
import bedImg from '../../../assets/room_types/green/bed.png'
import boatImg from '../../../assets/room_types/green/boat.png'
import bungalowImg from '../../../assets/room_types/green/bungalow.png'
import camperImg from '../../../assets/room_types/green/camper.png'
import bigHouseImg from '../../../assets/room_types/green/house.png'
import lodgeImg from '../../../assets/room_types/green/maisonette.png'
import roomImg from '../../../assets/room_types/green/room.png'
import houseImg from '../../../assets/room_types/green/smallhouse.png'
import studioImg from '../../../assets/room_types/green/studio.png'
import tentImg from '../../../assets/room_types/green/tent.png'
import villaImg from '../../../assets/room_types/green/villa.png'
import { Select } from '../../../components/FormBuilder'
import { RoomType } from '../../../models/Room'
import { IWithSize } from '../../BookingCalendar/Calendar/Calendar'

function RoomTypes({
  t,
  width,
  size = 1,
}: WithTranslation & { width: string } & IWithSize) {
  return (
    <Select.ReduxField
      size={size}
      name={'type'}
      label={t('room_type')}
      width={width}
      className={'room-form-type-select'}
    >
      <Select.Option
        data-cy={'room-form-type-1-select-option'}
        value={RoomType.Room}
        icon={roomImg}
      >
        <Trans i18nKey={'room_type_1'} />
      </Select.Option>
      <Select.Option
        data-cy={'room-form-type-2-select-option'}
        icon={apartamentImg}
        value={RoomType.Apartament}
      >
        <Trans i18nKey={'room_type_2'} />
      </Select.Option>
      <Select.Option
        data-cy={'room-form-type-3-select-option'}
        icon={houseImg}
        value={RoomType.House}
      >
        <Trans i18nKey={'room_type_3'} />
      </Select.Option>
      <Select.Option
        data-cy={'room-form-type-4-select-option'}
        icon={studioImg}
        value={RoomType.Studio}
      >
        <Trans i18nKey={'room_type_4'} />
      </Select.Option>
      <Select.Option
        data-cy={'room-form-type-5-select-option'}
        icon={bungalowImg}
        value={RoomType.Bungalow}
      >
        <Trans i18nKey={'room_type_5'} />
      </Select.Option>
      <Select.Option
        data-cy={'room-form-type-6-select-option'}
        icon={camperImg}
        value={RoomType.Camper}
      >
        <Trans i18nKey={'room_type_6'} />
      </Select.Option>
      <Select.Option
        data-cy={'room-form-type-7-select-option'}
        icon={villaImg}
        value={RoomType.Villa}
      >
        <Trans i18nKey={'room_type_7'} />
      </Select.Option>
      <Select.Option
        data-cy={'room-form-type-8-select-option'}
        icon={tentImg}
        value={RoomType.Tent}
      >
        <Trans i18nKey={'room_type_8'} />
      </Select.Option>
      <Select.Option
        data-cy={'room-form-type-9-select-option'}
        icon={lodgeImg}
        value={RoomType.Lodge}
      >
        <Trans i18nKey={'room_type_9'} />
      </Select.Option>
      <Select.Option
        data-cy={'room-form-type-10-select-option'}
        icon={bedImg}
        value={RoomType.Bed}
      >
        <Trans i18nKey={'room_type_10'} />
      </Select.Option>
      <Select.Option
        data-cy={'room-form-type-11-select-option'}
        icon={boatImg}
        value={RoomType.Boat}
      >
        <Trans i18nKey={'room_type_11'} />
      </Select.Option>
      <Select.Option
        data-cy={'room-form-type-12-select-option'}
        icon={bigHouseImg}
        value={RoomType.BigHouse}
      >
        <Trans i18nKey={'room_type_12'} />
      </Select.Option>
    </Select.ReduxField>
  )
}

export default withTranslation()(RoomTypes)
